<template>
  <FullScreenDialog
    v-model="dialog"
    without-padding
    title="Unità Di Misura"
    :route-father="routeFather"
  >
    <template v-slot:header-actions>
      <v-btn text link @click="goToNew" :disabled="isLicenseBlocked">
        <v-icon class="mr-2">mdi-plus</v-icon> Nuovo
      </v-btn>
    </template>
    <template v-slot:content>
      <div class="d-flex justify-center align-center mb-2" style="width: 100%">
        <AdvancedFilter
          style="width:99%; height: 100%"
          v-model="filtersValue"
          :filters="filterTypes"
          :external-filter="externalFilter"
          @apply-filters="applyFilters"
        >
          <template v-slot:chip-custom-name="{filter}">
            Nome: {{ filter.value }}
          </template>

        </AdvancedFilter>
      </div>
      <div 
        :style="{
          'height': $vuetify.breakpoint.smAndDown ? '81%' : '86%', 
          'overflow-y': 'hidden'
        }" 
        ref="dataTableWrapper"
      >
        <TypeDataTable
          v-model="selected"
          loading-text="Caricamento Unità Di Misura..."
          :headers="headers"
          :loading="loading"
          :items="filteredUnitOfMeasures"
          :page.sync="page"
          :showSelect="false"
          :row-per-page.sync="rowPerPage"
          :total-pages.sync="totalPages"
          :height="dataTableHeight"
          @edit="handleEdit"
          @delete="handleDelete"
          @dblclick:row="handleEditDoubleClick"
        ></TypeDataTable>
      </div>
    </template>
  </FullScreenDialog >
</template>

<script>
import FullScreenDialog from '@/components/common/FullScreenDialog.vue'
import StandardMenu from '@/components/common/StandardMenu.vue'
import TypeDataTable from '@/components/common/TypeDataTable.vue'
import AdvancedFilter from "@/components/common/AdvancedFilter.vue";
import unitOfMeasuresService from '@/services/unitOfMeasures/unitOfMeasures.service.js'

export default {
  name: "UnitOfMeasuresRegistryList",
  components: {
    FullScreenDialog,
    AdvancedFilter,
    TypeDataTable,
    StandardMenu
  },
  data: function() {
    let props = this.$router.resolve({name: 'Warehouse'});

    return {
      dialog: true,
      loadingItems: false,
      loadingHeaders: false,
      routeFather: props.href,
      selected: undefined,
      dataTableHeightValue: 400,
      unitOfMeasures: [],
      headers: [],
      page: 1,
      rowPerPage: 100,
      totalPages: 0,
      resizeListener: undefined,
      filterTypes: [
        { type: 'string', operator: 'like', field: 'description', name: 'Descrizione', label: 'Descrizione', color: "", value: undefined, },
      ],
      externalFilter: { type: 'custom', operator: 'custom', field: 'name', name: 'Nome', label: 'Nome', color: "", value: undefined },
      filtersValue: [],
      isLicenseBlocked: undefined
    }
  },
  props: {
    filters: {
      type: Array,
      default: () => []
    }
  },
  mounted: function() {
    this.fetchHeaders()
    this.filtersValue = this.filters
    this.fetchUnitOfMeasures()

    this.dataTableHeightValue = this.$refs.dataTableWrapper.offsetHeight - 60

    this.dataTableHeightValue = this.$refs.dataTableWrapper.offsetHeight - 60
    this.resizeListener = function() {
      this.dataTableHeightValue = this.$refs.dataTableWrapper.offsetHeight - 60
    }
    this.resizeListener = this.resizeListener.bind(this)
    window.addEventListener('resize', this.resizeListener)
  },
  beforeDestroy: function() {
    window.removeEventListener('resize', this.resizeListener)
  },
  methods: {
    fetchUnitOfMeasures() {
      let filters = [...this.filtersValue]
      this.loadingItems = true
      unitOfMeasuresService.list(this.page, this.rowPerPage, filters).then((results) => {
        if(this.rowPerPage != results.rowPerPage) {
          this.rowPerPage = results.rowPerPage
        }

        if(this.page != results.page) {
          this.page = results.page
        }

        this.totalPages = results.totalPages
        if(this.totalPages < this.page) {
          this.page = this.totalPages
        }

        this.unitOfMeasures = results.rows
        this.loadingItems = false
      })
    },
    applyFilters() {
      this.fetchUnitOfMeasures();
    },
    fetchHeaders() {
      this.loadingHeaders = true
      unitOfMeasuresService.fields().then((headers) => {
        this.headers = headers
        this.loadingHeaders = false
      })
    },
    handleEdit(unitOfMeasure) {
      this.$router.push({
        name: 'UnitOfMeasuresRegistryEditForm',
        params: {
          id: unitOfMeasure.id,
          filters: this.filtersValue
        },
        query: {
          pathToGoBack: this.$router.resolve({name: 'UnitOfMeasuresRegistryList'}).href,
          pathName: "UnitOfMeasuresRegistryList"
        }
      })
    },
    handleEditDoubleClick(row, {item: unitOfMeasure}) {
      this.$router.push({
        name: 'UnitOfMeasuresRegistryEditForm',
        params: {
          id: unitOfMeasure.id,
          filters: this.filtersValue
        },
        query: {
          pathToGoBack: this.$router.resolve({name: 'UnitOfMeasuresRegistryList'}).href,
          pathName: "UnitOfMeasuresRegistryList"
        }
      })
    },
    handleDelete(unitOfMeasure) {
      let confirmed = confirm('Sei sicuro di voler eliminare ' + unitOfMeasure.name + ' ?')

      if(confirmed) {
        this.loadingItems = true
        unitOfMeasuresService.delete(unitOfMeasure).then(() => {
          this.fetchUnitOfMeasures()
          this.loadingItems = false
        })
      }
    },
    goToNew() {
      this.$router.push({
        name: 'UnitOfMeasuresRegistryNewForm',
        query: {
          pathToGoBack: this.$router.resolve({name: 'UnitOfMeasuresRegistryList'}).href
        }
      })
    }
  },
  computed: {
    filteredUnitOfMeasures() {
      return this.unitOfMeasures
    },
    loading() {
      return this.loadingItems || this.loadingHeaders
    },
    dataTableHeight() {
      return this.dataTableHeightValue + 'px'
    }
  },
  watch: {
    page() {
      this.fetchUnitOfMeasures()
    },
    rowPerPage() {
      this.fetchUnitOfMeasures()
    },
  },
  isLicenseBlocked: {
    bind: 'isLicenseBlocked'
  }
}
</script>